/**
 * @name NoticePrivacy
 * @description Componente del aviso de privacidad de Talentry
 * @author Ricardo Guerra
 */

import React from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Lines } from '@components';
import { Flex, MUI, Typography } from '@styles';

const NoticePrivacy = (props) => {

  // Redirect to Login
  const goLogin = () => {
    const { history } = props;
    history.push('/login');
  };

  return (
    <>
      <Styled.TopBar>
        <Styled.TalentryLogo
          src="https://assets.talentry.io/logo/TAL_logo.svg"
          alt="Talentry"
        />
      </Styled.TopBar>
      <Lines
        direction="horizontal"
        firstLine={{ size: 75, color: 'blueMedium' }}
        secondLine={{ size: 25, color: 'red' }}
      />

      <Styled.NoticePrivacyWrapper>
        <Flex.Row padding="16px" justifyContent="center">
          <Typography.H3>{'Aviso de privacidad'}</Typography.H3>
        </Flex.Row>

        <MUI.Box padding="16px">
          <Typography.H5 color="purple">{'I. INTRODUCCIÓN'}</Typography.H5>
          <br />
          <Styled.Text>{'Cuando usas Talentry, en lo sucesivo Talentry (de la cuál es responsable TESSELAR SOLUCIONES, S.A. DE C.V.) nos confías tus datos personales. Nos comprometemos a mantener esa confianza. Para esto, comenzaremos por ayudarte a comprender nuestras prácticas de privacidad.'}</Styled.Text>
          <br />
          <Styled.Text>{'En este aviso se describen los datos personales que recopilamos, cómo los usamos y compartimos, y sus opciones con respecto a ellos.'}</Styled.Text>
        </MUI.Box>

        <MUI.Box padding="16px">
          <Typography.H5 color="purple">{'II. RESPONSABLE'}</Typography.H5>
          <br />
          <Styled.Text>
            <Typography.Strong>{'TESSELAR SOLUCIONES, S.A. DE C.V.'}</Typography.Strong>
            {', en adelante TESSELAR, con domicilio en la Avenida Mariano Otero 1105, Col. Rinconada del Bosque, C.P. 44530 en Guadalajara, Jalisco, es responsable de recabar sus datos personales, del uso que se le dé a los mismos y de su protección.'}
          </Styled.Text>
        </MUI.Box>

        <MUI.Box padding="16px">
          <Typography.H5 color="purple">{'III. CONTACTO'}</Typography.H5>
          <br />
          <Styled.Text>{'En todo lo relacionado con el tratamiento y protección de sus datos personales, le informamos que puede ser contactado en el domicilio antes indicado, vía telefónica en el número 33-80-00-69-09, o bien, mediante correo electrónico dirigido a la siguiente dirección legal@tesselar.com.'}</Styled.Text>
        </MUI.Box>

        <MUI.Box padding="16px">
          <Typography.H5 color="purple">{'IV. FINALIDAD'}</Typography.H5>
          <br />
          <Styled.Text>{'IV.I. Sus datos personales serán utilizados para las siguientes finalidades primarias:'}</Styled.Text>
          <br />
          <Styled.Text>
            <Typography.Strong>{`- (i) `}</Typography.Strong>
            {'Cuando usted lo solicite, proporcionar información sobre los servicios y productos que TESSELAR ofrece.'}
          </Styled.Text>
          <br />
          <Styled.Text>
            <Typography.Strong>{`- (ii) `}</Typography.Strong>
            {'La gestión, administración, prestación, ampliación, y mejora de los servicios en los que el usuario decida suscribirse, darse de alta o utilizar la adecuación de dichos servicios y productos a las preferencias y gustos de los usuarios.'}
          </Styled.Text>
          <br />
          <Styled.Text>
            <Typography.Strong>{`- (iii) `}</Typography.Strong>
            {'El estudio de la utilización de los servicios y productos por parte de los usuarios.'}
          </Styled.Text>
          <br />
          <Styled.Text>
            <Typography.Strong>{`- (iv) `}</Typography.Strong>
            {'El diseño de nuevos servicios relacionados con dichos servicios y productos.'}
          </Styled.Text>
          <br />
          <Styled.Text>
            <Typography.Strong>{`- (v) `}</Typography.Strong>
            {'Cumplimiento legal y contractual.'}
          </Styled.Text>
          <br />
          <Styled.Text>{'IV.II. De manera adicional, utilizaremos su información personal para las siguientes finalidades secundarias:'}</Styled.Text>
          <br />
          <Styled.Text>
            <Typography.Strong>{`- (i) `}</Typography.Strong>
            {'El envío de actualizaciones de los servicios y productos.'}
          </Styled.Text>
          <br />
          <Styled.Text>
            <Typography.Strong>{`- (ii) `}</Typography.Strong>
            {'El envío por medios tradicionales y electrónicos de información técnica, operativa y comercial acerca de productos y servicios ofrecidos por la Empresa y/o por terceros actualmente y en el futuro.'}
          </Styled.Text>
          <br />
          <Styled.Text>
            <Typography.Strong>{`- (iii) `}</Typography.Strong>
            {'El envío de formularios de encuestas que el usuario no queda obligado a contestar. Si usted, posteriormente desea que sus datos personales no sean tratados para estas finalidades secundarias antes mencionadas, puede enviar un correo electrónico a legal@tesselar.com.'}
          </Styled.Text>
        </MUI.Box>

        <MUI.Box padding="16px">
          <Typography.H5 color="purple">{'V. RECOPILACIÓN Y USO DE LOS DATOS'}</Typography.H5>
          <br />
          <Styled.Text>{'V.I. Datos recopilados'}</Styled.Text>
          <br />
          <Styled.Text>{'Talentry recopila los siguientes datos personales:'}</Styled.Text>
          <br />
          <Styled.Text>{'• Datos que los usuarios (colaboradores) proporcionan a Talentry, como los que brindan cuando crean sus cuentas.'}</Styled.Text>
          <br />
          <Styled.Text>{'• Datos que se generan cuando se utilizan nuestros servicios, como los detalles del dispositivo, ubicación y uso de la app.'}</Styled.Text>
          <br />
          <Styled.Text>{'V.II. Datos creados durante el uso de nuestros servicios:'}</Styled.Text>
          <br />
          <Styled.Text>{'• Datos de ubicación (colaborador): Recopilamos datos de ubicación precisos o aproximados de los colaboradores, p. ej., para realizar un registro de entrada y así permitir que arroje si está dentro del rango, manifestando sucursal exacta en donde se encuentra el colaborador, así como la modalidad de trabajo ya sea Presencial o Home Office. TESSELAR recopila esta información cuando la app de Talentry se ejecuta en primer plano (app abierta y en pantalla) o en segundo plano (app abierta, pero no en pantalla) en su dispositivo móvil.'}</Styled.Text>
          <br />
          <Styled.Text>{'Recopilamos dichos datos de los dispositivos móviles de los usuarios si se nos autoriza a hacerlo. (Consulta la sección Opciones y transparencia a continuación para conocer cómo los usuarios (colaboradores) pueden permitir la recopilación de datos de ubicación). Talentry recopila esta información desde el momento en que se ingresa a la app hasta que cierra sesión (y esta recopilación se puede indicar con un icono o una notificación en el dispositivo móvil, según el sistema operativo) y cada vez que la app se ejecuta en primer plano (app abierta y en pantalla) en el dispositivo móvil.'}</Styled.Text>
          <br />
          <Styled.Text>{'Los usuarios (colaboradores) pueden usar las app de Talentry sin permitir que se recopilen datos de ubicación precisa de sus dispositivos móviles. Sin embargo, esto puede afectar algunas funciones de la app de Talentry. P. ej., si un usuario (colaborador) no permite que se recopilen datos de ubicación, no se podrá realizar el registro de su entrada, ni mucho menos la forma en la que esta realizando su trabajo como lo es la modalidad Presencial o Home Office.'}</Styled.Text>
        </MUI.Box>

        <MUI.Box padding="16px">
          <Typography.H5 color="purple">{'VI. DATOS PERSONAL RECABADOS'}</Typography.H5>
          <br />
          <Styled.Text>{'En virtud del uso de la app denominada Talentry de la cuál es responsable TESSELAR SOLUCIONES, S.A. DE C.V., quién tratará los datos personales, en su calidad de encargado, usted proporcionará en su calidad de colaborador a través de nuestro sitio web www.tesselar.mx o bien, mediante la app denominada Talentry.'}</Styled.Text>
          <br />
          <Styled.Text>{'Para las finalidades señaladas en el presente Aviso de Privacidad, podemos recabar sus datos personales de distintas formas: cuando usted nos los proporciona directamente, cuando visita nuestro sitio de internet o utiliza nuestro servicio en línea, así como el uso de la app, y cuando obtenemos información a través de otras fuentes que están permitidas por la Ley.'}</Styled.Text>
          <br />
          <Styled.Text>{'Recabamos sus datos personales de forma directa cuando usted mismo nos los proporciona por diversos medios, como cuando nos comunica sus datos de contacto para recibir información de nuestros servicios a través de nuestros servicios de internet o nos da información con objeto de que le prestemos un servicio en particular.'}</Styled.Text>
          <br />
          <Styled.Text>{'Los datos que obtenemos por este medio son de contacto, laborales, académicos, de identificación, migratorios, patrimoniales y financieros.'}</Styled.Text>
        </MUI.Box>

        <MUI.Box padding="16px">
          <Typography.H5 color="purple">{'VII. DATOS PERSONAL SENSIBLES'}</Typography.H5>
          <br />
          <Styled.Text>{'Además de los datos personales mencionados anteriormente, para las finalidades informadas en el presente Aviso de Privacidad utilizaremos los siguientes datos personales considerados como sensibles que requieren de especial protección son sobre ideología, creencias religiosas, filosóficas o morales, opiniones políticas, de salud y origen étnico o racial. Mismos que se manejarán de manera ética, profesional y con estricto apego a la Ley Federal de Protección de Datos Personales en Posesión de los Particulares.'}</Styled.Text>
        </MUI.Box>

        <MUI.Box padding="16px">
          <Typography.H5 color="purple">{'VIII. LIMITACIÓN'}</Typography.H5>
          <br />
          <Styled.Text>{'A fin de que sus datos personales no sean tratados para fines mercadotécnicos, publicitarios o de prospección comercial por nuestra parte, puede contactarnos a través del número 33-80-00-69-09 o bien, mediante correo electrónico dirigido a la siguiente dirección legal@tesselar.com, solicitando que se le indique el procedimiento para limitar el uso de su información personal.'}</Styled.Text>
        </MUI.Box>

        <MUI.Box padding="16px">
          <Typography.H5 color="purple">{'IX. DERECHOS DE ACCESO, RECTIFICACIÓN, CANCELACIÓN Y OPOSICIÓN (ARCO)'}</Typography.H5>
          <br />
          <Styled.Text>{'Usted tiene derecho de acceder a sus datos personales que poseemos y a los detalles del tratamiento de los mismos, así como a rectificarlos en caso de ser inexactos o incompletos, cancelarlos cuando considere que no se requieren para alguna de las finalidades señaladas en el presente aviso de privacidad, que estén siendo utilizados para finalidades no consentidas o haya finalizado la relación contractual o de servicio, o bien, oponerse al tratamiento de los mismos para fines específicos.'}</Styled.Text>
          <br />
          <Styled.Text>{'Para poder ejercer cualquiera de los derechos antes mencionados, es necesario que presente su solicitud en el domicilio ubicado en Avenida Mariano Otero 1105, Col. Rinconada del Bosque, C.P. 44530 en Guadalajara, Jalisco.'}</Styled.Text>
          <br />
          <Styled.Text>{'Su solicitud deberá contener la siguiente información:'}</Styled.Text>
          <br />
          <Styled.Text>{'- El nombre del titular y domicilio para comunicarle la respuesta'}</Styled.Text>
          <br />
          <Styled.Text>{'- Los documentos que acreditan la identidad o, en su caso, la representación legal del titular'}</Styled.Text>
          <br />
          <Styled.Text>{'- La descripción clara y precisa de los datos personales respecto de los que se busca ejercer alguno de los derechos antes mencionados, y'}</Styled.Text>
          <br />
          <Styled.Text>{'- Cualquier otro elemento o documento que facilite la localización de los datos personales'}</Styled.Text>
          <br />
          <Styled.Text>{'Dentro de un plazo máximo de 20 días hábiles, TESSELAR atenderá su petición y le dará respuesta por escrito con acuse de recibo.'}</Styled.Text>
        </MUI.Box>

        <MUI.Box padding="16px">
          <Typography.H5 color="purple">{'X. OPCIONES Y TRANSPARENCIA'}</Typography.H5>
          <br />
          <Styled.Text>{'Talentry permite a los usuarios acceder o controlar los datos que recopila, incluso a través de los siguientes medios:'}</Styled.Text>
          <br />
          <Styled.Text>{'• Configuración de privacidad'}</Styled.Text>
          <br />
          <Styled.Text>{'• Permisos del dispositivo'}</Styled.Text>
          <br />
          <Styled.Text>{'Talentry también permite a los usuarios solicitar acceso o copias de sus datos, cambios, actualizaciones o eliminación de sus cuentas, o que TESSELAR restrinja el procesamiento de su información personal, como se menciona en la sección de Revocación.'}</Styled.Text>
          <br />
          <Styled.Text>{'X.I. Configuración de privacidad'}</Styled.Text>
          <br />
          <Styled.Text>{'Mediante el menú Configuración > Privacidad en la app de Talentry, los usuarios (colaboradores) pueden establecer o actualizar sus preferencias sobre la recopilación y uso compartido de datos de ubicación y notificaciones.'}</Styled.Text>
          <br />
          <Styled.Text>{'Recopilación de datos de ubicación: Los usuarios (colaboradores) pueden activar o desactivar en sus dispositivos la opción que permite que Talentry recopile datos de ubicación de sus dispositivos móviles. Se accede a través del menú Configuración > Privacidad > Ubicación.'}</Styled.Text>
          <br />
          <Styled.Text>{'Compartir ubicación en tiempo real: Los usuarios (colaboradores) pueden activar o desactivar en el dispositivo la opción que permite que Talentry comparta al Administrador los datos de ubicación en tiempo real de sus dispositivos móviles. Se accede a través del menú Configuración > Privacidad >Ubicación.'}</Styled.Text>
          <br />
          <Styled.Text>{'X.II. Permisos del dispositivo'}</Styled.Text>
          <br />
          <Styled.Text>{'La mayoría de las plataformas de dispositivos móviles (iOS, Android, etc.) definieron ciertos tipos de datos de los dispositivos a los que las apps no pueden acceder sin la autorización del propietario. Estas plataformas tienen diferentes métodos para obtener dichos permisos. Verifique la configuración disponible en su dispositivo o consulte con su proveedor.'}</Styled.Text>
        </MUI.Box>

        <MUI.Box padding="16px">
          <Typography.H5 color="purple">{'XI. REVOCACIÓN'}</Typography.H5>
          <br />
          <Styled.Text>{'En todo momento, usted podrá revocar el consentimiento que nos ha otorgado para el tratamiento de sus datos personales, a fin de que dejemos de hacer uso de los mismos. Para poder ejercer este derecho, es necesario que presente su solicitud en el domicilio ubicado en Avenida Mariano Otero 1105, Col. Rinconada del Bosque, C.P. 44530 en Guadalajara, Jalisco.'}</Styled.Text>
          <br />
          <Styled.Text>{'Su solicitud deberá contener la siguiente información:'}</Styled.Text>
          <br />
          <Styled.Text>{'- El nombre del titular y domicilio para comunicarle la respuesta'}</Styled.Text>
          <br />
          <Styled.Text>{'- Los documentos que acreditan la identidad o, en su caso, la representación legal del titular'}</Styled.Text>
          <br />
          <Styled.Text>{'- La descripción clara y precisa de los datos personales respecto de los que se busca ejercer alguno de los derechos antes mencionados, y'}</Styled.Text>
          <br />
          <Styled.Text>{'- Cualquier otro elemento o documento que facilite la localización de los datos personales'}</Styled.Text>
          <br />
          <Styled.Text>{'Dentro de un plazo máximo de 20 días hábiles, TESSELAR atenderá su petición y le dará respuesta por escrito con acuse de recibo.'}</Styled.Text>
          <br />
          <Styled.Text>{'Asimismo, usted deberá considerar que, para ciertos fines, la revocación de su consentimiento implicará que no le podamos seguir prestando el servicio que nos solicitó, o la conclusión de su relación con nosotros.'}</Styled.Text>
        </MUI.Box>

        <MUI.Box padding="16px">
          <Typography.H5 color="purple">{'XII. TRANSFERENCIAS'}</Typography.H5>
          <br />
          <Styled.Text><Typography.Medium>{'Para el personal de TESSELAR'}</Typography.Medium></Styled.Text>
          <br />
          <Styled.Text>{'Le informamos que sus datos personales podrían ser compartidos dentro y fuera del país, está transferencia se realiza con el fin de administrar nuestra red de profesionales.'}</Styled.Text>
          <br />
          <Styled.Text>{'Asimismo, le informamos que para realizar la transferencia antes mencionada no requerimos obtener su consentimiento, ya que esta es necesaria en virtud del contrato laboral celebrado entre usted y TESSELAR.'}</Styled.Text>
          <br />
          <Styled.Text>{'Nos comprometemos a no transferir su información personal a terceros sin su consentimiento, salvo las excepciones previstas en el artículo 37 de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares, así como a realizar esta transferencia en los términos que fija dicha ley.'}</Styled.Text>
          <br />
          <Styled.Text><Typography.Medium>{'Para clientes de TESSELAR'}</Typography.Medium></Styled.Text>
          <br />
          <Styled.Text>{'Le informamos que sus datos personales podrían ser compartidos dentro y fuera del país, está transferencia se realiza para reportes comerciales, seguimiento de proyectos, demostración de experiencia y especialidad.'}</Styled.Text>
          <br />
          <Styled.Text>{'En caso de manifestar su negativa para dicha transferencia, puede contactarnos a través del número 33-80-00-69-09, o bien, mediante correo electrónico dirigido a la siguiente dirección legal@tesselar.com, solicitando se le indique el procedimiento para revocar el consentimiento.'}</Styled.Text>
          <br />
          <Styled.Text>{'Nos comprometemos a no transferir su información personal a terceros sin su consentimiento, salvo las excepciones previstas en el artículo 37 de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares, así como a realizar esta transferencia en los términos que fija dicha ley.'}</Styled.Text>
        </MUI.Box>

        <MUI.Box padding="16px">
          <Typography.H5 color="purple">{'XIII. PROCEDIMIENTOS Y REQUISITOS LEGALES'}</Typography.H5>
          <br />
          <Styled.Text>{'Podemos usar datos personales para investigar o abordar reclamos o disputas relacionados con el uso de los servicios de Talentry, a fin de cumplir con los requisitos de las leyes, reglamentaciones, licencias o acuerdos de operación vigentes, o en virtud de un procedimiento legal o de una solicitud gubernamental, incluso de la fuerza del orden público.'}</Styled.Text>
          <br />
          <Styled.Text>{'Talentry realiza las actividades anteriores porque son necesarias para satisfacer los intereses legítimos de TESSELAR de investigar y de responder los reclamos y las disputas relacionados con el uso de los servicios y las funciones de Talentry, o para cumplir con los requisitos legales aplicables.'}</Styled.Text>
        </MUI.Box>

        <MUI.Box padding="16px">
          <Typography.H5 color="purple">{'XIV. AUTORIDADES QUE VELAN POR LA PROTECCIÓN DE TUS DATOS PERSONALES'}</Typography.H5>
          <br />
          <Styled.Text>
            {'Si consideras que tu derecho a la protección de tus datos personales ha sido lesionado por alguna conducta u omisión y/o presumes alguna violación a las disposiciones previstas en la Ley Federal de Protección de Datos Personales en Posesión de los Particulares, su Reglamento y demás ordenamientos aplicables, podrás interponer tu inconformidad o denuncia ante el Instituto Nacional de Transparencia, Acceso a la Información y Protección de Datos Personales (INAI).  Para más información, te sugerimos visitar su página oficial de Internet '}
            <Typography.TextLink href="https://www.inai.org.mx/" target="_blank">{'www.inai.org.mx.'}</Typography.TextLink>
          </Styled.Text>
        </MUI.Box>

        <MUI.Box padding="16px">
          <Typography.H5 color="purple">{'XV. MEDIOS AUTOMÁTICOS PARA RECABAR DATOS PERSONALES'}</Typography.H5>
          <br />
          <Styled.Text>
            {'TESSELAR utiliza cookies para facilitar la navegación en el sitio web '}
            <Typography.TextLink href="https://www.tesselar.mx/" target="_blank">{'www.tesselar.mx'}</Typography.TextLink>
            {' esto permite recopilar, analizar y conservar información relacionada con sus hábitos de navegación y uso de estos, en el momento mismo en que usted hace uso de nuestros servicios electrónicos.'}
          </Styled.Text>
          <br />
          <Styled.Text>{'Para más información de estas tecnologías y de como deshabilitarlas, puede solicitar información a través del número 33-80-00-69-09, o bien, mediante correo electrónico dirigido a la siguiente dirección legal@tesselar.com.'}</Styled.Text>
        </MUI.Box>

        <MUI.Box padding="16px">
          <Typography.H5 color="purple">{'XVI. MODIFICACIONES AL AVISO DE PRIVACIDAD'}</Typography.H5>
          <br />
          <Styled.Text>{'Nos reservamos el derecho de efectuar en cualquier momento modificaciones o actualizaciones al presente aviso de privacidad para la atención de novedades legislativas, políticas internas o nuevos requerimientos para la prestación u ofrecimiento de nuestros servicios o productos.'}</Styled.Text>
          <br />
          <Styled.Text>
            {'Estas modificaciones estarán disponibles al público a través de nuestro sitio web en la dirección '}
            <Typography.TextLink href="https://www.tesselar.mx/" target="_blank">{'www.tesselar.mx'}</Typography.TextLink>
            {' donde se podrá consultar la versión más reciente de este aviso de privacidad.'}
          </Styled.Text>
          <br />
          <Styled.Text>{'Fecha ultima de actualización 27 de octubre de 2021.'}</Styled.Text>
        </MUI.Box>

        <MUI.Box padding="16px">
          <Typography.H5 color="purple">{'XVII. CONFIDENCIALIDAD'}</Typography.H5>
          <br />
          <Styled.Text>{'La información contenida en el envío de correo electrónico y en cualquier archivo adjunto es enviada únicamente para el uso de la persona o entidad a quién esta dirigida y de cualquier otra persona que este autorizada para recibirla. Este comunicado puede contener información confidencial y/o legalmente privilegiada. Si usted no es el destinatario o ha recibido esta comunicación por error, le agradecemos destruir este correo y sus archivos adjuntos inmediatamente y notificar al emisor principal de dicho correo. No distribuya, imprima o reproduzca la información contenida en el correo o en sus archivos adjuntos, ya sea total o parcialmente, ya que está acción esta estrictamente prohibida y podría ser ilegal. TESSELAR no es responsable por la correcta y completa transmisión de la información contenida en está comunicación y tampoco por cualquier retraso en su recepción.'}</Styled.Text>
        </MUI.Box>

        <MUI.Box padding="16px">
          <MUI.ButtonCTA
            type="button"
            color="primary"
            onClick={goLogin}
            margin="false"
          >
            {i18n.t('GenericMessages.goTalentry')}
          </MUI.ButtonCTA>
        </MUI.Box>
      </Styled.NoticePrivacyWrapper>
    </>
  );
};

NoticePrivacy.propTypes = {
  location: PropTypes.object,
  history: PropTypes.object
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.TopBar = styled.div`
  min-height: 60px;
  max-height: 60px;
`;

Styled.TalentryLogo = styled.img`
  height: 60px;
  margin: 5px 0 0 0;
`;

Styled.NoticePrivacyWrapper = styled.div`
  display: flex;
  flex-flow: column;
  height: 100%;
  width: 80%;
  margin: auto;
  padding: 16px;

  @media (max-width: 600px) {
    width: 100%;
  }
`;

Styled.Text = styled(Typography.Text)`
  text-align: justify;
`;

export default NoticePrivacy;